/**
 * File menus.js.
 *
 * Handles toggling the navigation menu for small screens and enables TAB key
 * navigation support for dropdown menus.
 */
( function() {
	var button, menu, links, i, len;

	const btnAttrib = 'data-menu-toggle'; 	// Attribute name that buttons use to target a menu
	const menuAttrib = 'data-menu'; 			// Attribute where menu name is set
	const stateName = 'toggled'; 				// the class the menu and button get when clicked
	let menuListName = ''

	// Get buttons that target a menu
	buttons = document.querySelectorAll('[' + btnAttrib + ']');
	if ( 'undefined' === typeof buttons ) {
		return;
	}

	// Go over each button and setup menu toggles
	buttons.forEach( button => {
		let menuName, menu, listName, list, links

		menuName = button.getAttribute(btnAttrib);

		menu = document.querySelector('[' + menuAttrib + '="' + menuName + '"]');
		// Hide menu toggle button if menu is empty and return early.
		if ( 'undefined' === typeof menu ) {
			return;
		}

		submenuAccess(menu);

		linkedButtons = document.querySelectorAll('[' + btnAttrib + '="' + menuName +'"]');

		button.onclick = function() {
			//toggleState(button, stateName);							// Give button state class
			toggleState(menu, stateName); 							// Give menu state class
			toggleState(document.body, menuName + '-' + stateName); // Give body menu name + state class

			if ( 'undefined' != typeof linkedButtons ) {
				linkedButtons.forEach( linkedButton => {
					toggleState(linkedButton, stateName);							// Give button state class
				});
			}
		}		

		list = menu.getElementsByTagName('ul')[0];
		// Hide menu toggle button if menu is empty and return early.
		if ( 'undefined' === typeof list ) {
			return;
		}

		listName = menuName + '-list';
		list.setAttribute( 'aria-expanded', 'false' );
		if ( -1 === list.className.indexOf( listName ) ) {
			list.className += ' ' + listName;
		}

		links = list.getElementsByTagName( 'a' );
		// Each time a menu link is focused or blurred, toggle focus.
		for ( i = 0, len = links.length; i < len; i++ ) {
			let link = links[i];
			let listLength = links.length;
			link.addEventListener( 'focus', function(){
				toggleFocus( link, listLength, listName );
			}, false );
			link.addEventListener( 'blur', function(){
				toggleFocus( link, listLength, listName );
			}, false );
		}

	});

	// General function to change state
	function toggleState(el, state) {

		el.classList.toggle(state);

		if (-1 !== el.className.indexOf( state ) ) {
			el.setAttribute( 'aria-expanded', 'false' );
		} else {
			el.setAttribute( 'aria-expanded', 'true' );
		}
	}

	/**
	 * Sets or removes .focus class on an element.
	 */
	function toggleFocus(self, listLength, listName) {
		// Move up through the ancestors of the current link until we hit .nav-menu.

		let parentMenu = self.closest('.menu');
		while ( -1 === self.className.indexOf( listName ) ) {

				// On li elements toggle the class .focus.
				if ( 'li' === self.tagName.toLowerCase() ) {
					if ( -1 !== self.className.indexOf( 'focus' ) ) {
						self.className = self.className.replace( ' focus', '' );
					} else {
						self.className += ' ' + 'focus';
					}
				}

			self = self.parentElement;
		}
	}


	/**
	 * Toggles `focus` class to allow submenu access on tablets.
	 */
	function submenuAccess( container ) {
		// console.log('go');
		var touchStartFn, i,
			parentLink = container.querySelectorAll( '.menu-item-has-children > a, .page_item_has_children > a' );

		if ( 'ontouchstart' in window ) {
			touchStartFn = function( e ) {
				var menuItem = this.parentNode, i;

				if ( ! menuItem.classList.contains( 'focus' ) ) {
					e.preventDefault();
					for ( i = 0; i < menuItem.parentNode.children.length; ++i ) {
						if ( menuItem === menuItem.parentNode.children[i] ) {
							continue;
						}
						menuItem.parentNode.children[i].classList.remove( 'focus' );
					}
					menuItem.classList.add( 'focus' );
				} else {
					menuItem.classList.remove( 'focus' );
				}
			};

			for ( i = 0; i < parentLink.length; ++i ) {
				parentLink[i].addEventListener( 'touchstart', touchStartFn, false );
			}
		}
	};


} )();
